import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllOrganizations,
  fetchAllDepartments,
  fetchAllTeams,
  fetchAllUserTypes,
} from "./cofig.warehosue.thunk";

const initialState = {
  organizations: [],
  departments: [],
  teams: [],
  userTypes: [],
  loading: false,
};

const configWarehouseSlice = createSlice({
  name: "configWarehouse",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOrganizations.fulfilled, (state, action) => {
        state.organizations = action.payload;
      })
      .addCase(fetchAllDepartments.fulfilled, (state, action) => {
        state.departments = action.payload;
      })
      .addCase(fetchAllTeams.fulfilled, (state, action) => {
        state.teams = action.payload;
      })
      .addCase(fetchAllUserTypes.fulfilled, (state, action) => {
        state.userTypes = action.payload;
      });
  },
});

export default configWarehouseSlice.reducer;
